import('./bootstrap')
  .then((bootstrap) => bootstrap.default())
  .catch((error) => console.error(error));
